import { Action } from '@ngrx/store';
import * as NgrxActions from 'macs-ngrx-actions';
import { createReducer } from 'macs-ngrx-actions';
import { HideLoader, ShowLoader } from '../actions/loader.actions';

export interface LoaderState {
  active: number;
  actionTypesInProgress: string[];
}

@NgrxActions.Store<LoaderState>({
  active: 0,
  actionTypesInProgress: [],
})
export class LoaderStore {
  @NgrxActions.Action(ShowLoader)
  showLoader(state: LoaderState, action: ShowLoader): LoaderState {
    const actionType =
      typeof action.payload.action === 'string'
        ? action.payload.action
        : action.payload.action.type;
    const isActionAlreadyInProgress = state.actionTypesInProgress.filter(
      (currentActionType: string) => currentActionType === actionType,
    ).length;

    if (isActionAlreadyInProgress) {
      return state;
    }
    const newActionTypesInProgress = [...state.actionTypesInProgress, actionType];

    return {
      ...state,
      active: newActionTypesInProgress.length,
      actionTypesInProgress: newActionTypesInProgress,
    };
  }

  @NgrxActions.Action(HideLoader)
  hideLoader(state: LoaderState, action: HideLoader): LoaderState {
    const triggerActionType =
      typeof action.payload === 'string'
        ? action.payload
        : (action.payload.action as any).triggerActionType;
    const newActionTypesInProgress = triggerActionType
      ? state.actionTypesInProgress.filter(
          (currentActionType: string) =>
            !triggerActionType
              .split('$')
              .some((actionType: string) => actionType === currentActionType),
        )
      : [];

    return {
      ...state,
      actionTypesInProgress: newActionTypesInProgress,
      active: state.active > 0 ? newActionTypesInProgress.length : 0,
    };
  }
}

export function loaderReducer(
  state: LoaderState | undefined,
  action: Action,
): LoaderState {
  return createReducer(LoaderStore)(state, action);
}

export const loaderVisibleSelector = (state: LoaderState): boolean => state.active > 0;

export const loaderInProgressTypesSelector = (state: LoaderState): string[] =>
  state.actionTypesInProgress;
